import { memo, useCallback } from 'react';

import { PublicAudioSampleRatesSelect } from '~/components/Filters/AudioSampleRateFilter/components/PublicAudioSampleRatesSelect';
import { type BaseFilterCardProps } from '~/components/Filters/FilterCard';
import { StringArrayFilterCard, type StringArrayFilterCardProps } from '~/components/Filters/StringArrayFilterCard';

type PublicAudioSampleRateFilterCardProps = {
  boardId: string | undefined;
} & BaseFilterCardProps;

export const PublicAudioSampleRateFilterCard = memo(({ boardId, ...props }: PublicAudioSampleRateFilterCardProps) => {
  const renderAudioSampleRatesSelect = useCallback<StringArrayFilterCardProps['StringSelect']>(
    (props) => <PublicAudioSampleRatesSelect boardId={boardId} {...props} />,
    [boardId],
  );

  return (
    <StringArrayFilterCard
      filter="audioSampleRates"
      filterCardType="audioSampleRate"
      StringSelect={renderAudioSampleRatesSelect}
      {...props}
    />
  );
});

PublicAudioSampleRateFilterCard.displayName = 'PublicAudioSampleRateFilterCard';
